import * as React from 'react';
import { getMylo } from '@src/app/login/selectors';
import { connect } from 'react-redux';
import { RootState } from '@src/app/_redux';
import { FormattedMessage } from 'react-intl';
import Mylo from 'mylo-js';

export interface MyloProps {
  mylo: Mylo;
}

export class MyloForm extends React.Component<MyloProps> {
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    const tokens = await this.props.mylo.getTokens(true);
    if (window.opener) {
      window.opener.location.href = 
          `/auth/success/#access_token=${tokens.access_token}&id_token=${tokens.id_token}`; 
    } else {
      window.location.href = 
          `/auth/success/#access_token=${tokens.access_token}&id_token=${tokens.id_token}`; 
    }
  }
  
  render() {
    return (
      <div className="mylo-view">

      <div>Click 
        <a href="#"
          onClick={() => window.close()}
          className=""
        >
          <FormattedMessage
            id="app.cancel"
            description="Cancel"
            defaultMessage=" here"
          />
        </a> to close window.
      </div>
    </div>);
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    mylo: getMylo(state), 
  };
};

export const MyloSuccess = connect(mapStateToProps)(MyloForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/components/Mylo.tsx